module.exports = __webpack_public_path__ + "img/login_img_2.e1461bfe.png";